<template>
  <v-row no-gutters
         v-ripple
         class="indicator-container std-background-white-1
         std-border-radius std-container-shadow-dense std-pointer">
    <v-col cols="12"
           :class="{'std-background-red-1': heat}"
           class="header-container d-flex align-center justify-center std-border-top-radius
           std-background-blue-2 std-text-md std-text-white-1 font-weight-medium">
      {{ title }}
    </v-col>
    <v-col cols="12"
           class="image-container d-flex align-center justify-center">
      <v-img :src="img"
             max-height="70%"
             contain>
      </v-img>
    </v-col>
    <v-col cols="12"
           class="text-container d-flex text-center std-text-xs std-text-blue-2 align-start px-4 font-weight-medium">
      {{text}}
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "GroupIndicator",
  props: {
    text: {
      type: String
    },
    title: {
      type: String,
    },
    img: {
      type: String
    },
    heat: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style scoped>
  .indicator-container {
    height: 285px;
  }

  .header-container {
    height: 40px;
  }

  .image-container {
    height: 160px;
  }

  .text-container {
    height: 85px;
  }
</style>